// extracted by mini-css-extract-plugin
module.exports = {"circle":"circle-IBAlV","timeInRoute":"timeInRoute-32Y1R","flightNumber":"flightNumber-2kE6i","route":"route-2w1Pc"};